<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <router-link :to="{ path: '/admin/bookVideo/list' }">
          <Button icon="ios-arrow-back" size="small" class="mr20">返回</Button>
        </router-link>
        <span
          class="ivu-page-header-title mr20"
          v-text="$route.params.id ? '编辑导读' : '添加导读'"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="formInfo"
            :model='formInfo'
            label-position="right"
            :label-width="120"
            :rules="ruleValidate"
            @submit.native.prevent>
        <FormItem label="导读名称：" prop="title">
          <Input
            v-model="formInfo.title"
            :maxlength='100'
            placeholder="请输入导读名称"
            class="perW50"
          />
        </FormItem>
        <FormItem label="导读分类：" prop="cate_id">
          <Select v-model="formInfo.cate_id" class="perW50">
            <Option v-for="item in cateList" :value="item.id" :key="item.id">
              {{item.title}}
            </Option>
          </Select>
        </FormItem>
        <!--   封面图-->
<!--        <FormItem label="封面图 (1000*750)">-->
<!--          <div class="demo-upload-list" v-for="item in uploadList" :key="item.url">-->
<!--            <template v-if="item.status === 'finished'">-->
<!--              <img :src="item.url">-->
<!--              <div class="demo-upload-list-cover">-->
<!--                <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>-->
<!--                <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>-->
<!--              </div>-->
<!--            </template>-->
<!--            <template v-else>-->
<!--              <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>-->
<!--            </template>-->
<!--          </div>-->
<!--          <Upload-->
<!--            v-if="uploadList.length==0"-->
<!--            ref="uploadThumb"-->
<!--            :show-upload-list="false"-->
<!--            :on-success="handleSuccess"-->
<!--            :format="['jpg','jpeg','png']"-->
<!--            :max-size="10240"-->
<!--            :on-format-error="handleFormatError"-->
<!--            :on-exceeded-size="handleMaxSize"-->
<!--            :before-upload="handleBeforeUpload"-->
<!--            type="drag"-->
<!--            :action="serverApiPic"-->
<!--            style="display: inline-block;width:100px;">-->
<!--            <div style="width: 100px;height:75px;line-height: 75px;">-->
<!--              <Icon type="ios-camera" size="20"></Icon>-->
<!--            </div>-->
<!--          </Upload>-->
<!--          <Modal title="查看" v-model="visible">-->
<!--            <img :src="imgUrl " v-if="visible" style="width: 100%">-->
<!--          </Modal>-->
<!--        </FormItem>-->
        <FormItem label="状态：">
          <RadioGroup v-model="formInfo.status">
            <Radio :label="1" class="radio">上架</Radio>
            <Radio :label="0">下架</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="是否精选推荐：">
          <RadioGroup v-model="formInfo.is_hot">
            <Radio :label="2" class="radio">是</Radio>
            <Radio :label="1">否</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="是否每日推荐：">
          <RadioGroup v-model="formInfo.is_recommend">
            <Radio :label="2" class="radio">是</Radio>
            <Radio :label="1">否</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="排序：">
          <InputNumber
            :min="0"
            class="perW10"
            v-model="formInfo.sort"
            placeholder="请输入排序"
          />
        </FormItem>
        <FormItem label="简介：" prop="introduction">
          <Input
            type="textarea"
            :rows="8"
            v-model="formInfo.introduction"
            placeholder="请输入简介"
            class="perW50"
          />
        </FormItem>
        <FormItem label="关联的图书条码：" prop="book_sn">
          <Input
            v-model="formInfo.book_sn"
            :maxlength='100'
            placeholder="请输入图书条码"
            class="perW50"
          />
        </FormItem>
        <form-item label="上传附件" prop="auth">
          <Upload ref="uploadFile"
                  :action="serverApiPic"
                  multiple
                  :on-success="handleSuccess3"
                  :format="['mp4']"
                  :max-size="51200"
                  :on-format-error="handleFormatError3"
                  :on-exceeded-size="handleMaxSize3">
            <Button icon="ios-cloud-upload-outline">请上传视频文件</Button>
          </Upload>
          <a :href="formInfo.audioarr" target="_blank">{{formInfo.audioarr}}</a>
        </form-item>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formInfo')" :loading="loading">
            <span v-if="!loading">提交</span>
            <span v-else>提交中...</span>
          </Button>
        </FormItem>
      </Form>
    </card>

  </div>

</template>
<style>
  .demo-upload-list {
    display: inline-block;
    width: 100px;
    height: 75px;
    text-align: center;
    line-height: 75px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
    margin-right: 4px;
  }

  .demo-upload-list img {
    width: 100%;
    height: 100%;
  }

  .demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .6);
  }

  .demo-upload-list:hover .demo-upload-list-cover {
    display: block;
  }

  .demo-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
</style>
<script>
import { getCate, addBooks, bookInfo } from '@/api/bookVideo'
import Setting from '@/setting'
import ueditor from '@/components/ueditorFrom/index'

export default {
  name: 'infoEdit',
  components: { ueditor },
  data () {
    return {
      loading: false,
      cateList: [],
      serverSrc: Setting.serverSrc,
      serverApiPic: Setting.serverApiPic,
      imgUrl: '',
      visible: false,
      formInfo: {
        id: 0,
        title: '',
        cate_id: 0,
        status: 1,
        sort: 0,
        image: '',
        introduction: '',
        audioarr: '',
        is_hot: 1,
        is_recommend: 1,
        book_sn: '',
        delpics: [], // 服务器待删除的照片
      },
      uploadList: [], // 缩咯图
      ruleValidate: {
        title: [
          { required: true, message: '请输入绘本名称', trigger: 'blur' }
        ],
        cate_id: [
          { required: true, message: '请选择绘本分类', trigger: 'change', type: 'number', min: 1 }
        ],
        introduction: [
          { required: true, message: '请输入绘本详情', trigger: 'blur' }
        ],
        audioarr: [
          { required: true, message: '请输入音频', trigger: 'blur' }
        ],
        book_sn: [
          { required: true, message: '请输入图书编号', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    if (this.$route.params.id !== '0' && this.$route.params.id) {
      this.goodsInfoEdit(this.$route.params.id)
    }
    this.getCateInfo()
  },
  mounted () {
  },
  methods: {
    handleView (url) {
      this.imgUrl = url
      this.visible = true
    },
    // 缩略图删除
    handleRemove (file) {
      const fileList2 = this.uploadList
      this.formInfo.delpics.push(file.url)
      this.uploadList.splice(fileList2.indexOf(file), 1)
      this.uploadList = []
    },
    // 缩略图
    handleSuccess (res, file) {
      let file_url = res.data.file_url
      if (file_url.substring(0, 5) === 'https') {
        file.url = file_url
      } else {
        file.url = this.serverSrc + file_url
      }
      this.uploadList = this.$refs.uploadThumb.fileList
    },
    handleSuccessCover (res, file) {
      let file_url = res.data.file_url
      if (file_url.substring(0, 5) === 'https') {
        file.url = file_url
      } else {
        file.url = this.serverSrc + file_url
      }
      this.uploadListCover = this.$refs.uploadCover.fileList
    },
    handleSuccess3 (res, file) {
      let file_url = res.data.file_url
      if (file_url.substring(0, 5) === 'https') {
        file.url = file_url
      } else {
        file.url = this.serverSrc + file_url
      }
      this.uploadFile = this.$refs.uploadFile.fileList
    },
    handleFormatError (file) {
      this.$Message.error('文件' + file.name + '格式错误，请上传jpg或png')
    },
    handleFormatError3 (file) {
      this.$Message.error('文件' + file.name + '格式错误，请上传mp4格式文件')
    },
    handleMaxSize3 (file) {
      this.$Message.error('文件' + file.name + '太大，不能大于50M')
    },
    handleMaxSize (file) {
      this.$Message.error('文件' + file.name + '太大，不能大于10M')
    },
    // 缩略图
    handleBeforeUpload () {
      const check = this.uploadList.length < 1
      if (!check) {
        this.$Message.error('只能上传1张图片')
      }
      return check
    },
    handleBeforeUploadCover () {
      const check = this.uploadListCover.length < 1
      if (!check) {
        this.$Message.error('只能上传1张图片')
      }
      return check
    },
    handleSubmit (name) {
      this.formInfo.audioarr = this.uploadFile[0]['url']
      // console.log(this.formInfo);return;
      // this.formInfo.share_thumb = this.uploadListCover[0]['url']
      // if (this.uploadPics.length <= 0) {
      //   this.$Message.error('轮播图必填')
      //   return
      // }
      // this.formInfo.pics = []
      // this.uploadPics.map((item, index) => {
      //   this.formInfo.pics.push(item.url)
      // })
      this.$refs[name].validate(valid => {
        if (valid) {
          this.loading = true
          addBooks(this.formInfo).then(res => {
            let msg = '添加成功'
            if (this.formInfo.id > 0) {
              msg = '编辑成功'
            }
            this.$Message.success(msg)
            if (res.code === 200) {
              setTimeout(() => {
                this.$router.push({ path: '/admin/bookVideo/list' })
              }, 500)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
            this.loading = false
          })
        }
      })
    },
    // 编辑加载数据
    goodsInfoEdit (id) {
      bookInfo(id).then(res => {
        this.formInfo = res.data
        this.uploadList = []
        this.uploadList.push({
          'url': this.formInfo.image,
          'showProgress': false,
          'percentage': 100,
          'status': 'finished'
        })
        //  缩略图
        this.uploadFile = []
        this.uploadFile.push({
          'url': this.formInfo.audioarr,
          'showProgress': false,
          'percentage': 100,
          'status': 'finished'
        })
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    // 获取分类
    getCateInfo () {
      getCate().then(res => {
        this.cateList = res.data
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
  }

}
</script>
